import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MenuModel } from 'src/app/core/models/menus/left-sidebar.model';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'core-left-sidebar',
  templateUrl: './left-sidebar.component.html',
  styleUrls: ['./left-sidebar.component.scss'],
})
export class LeftSidebarComponent implements OnInit {
  @Input() public menu: MenuModel;
  @Output() collapseClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  public collapseMenu: boolean;
  sidebarColor: string = environment.sidebarColor;
  isProduction: boolean = environment.production;

  constructor(private router: Router) { }


  ngOnInit(): void {
    this.collapseMenu = false;
  }

  public expandReduceMenu(route?: string): void {
    if (this.collapseMenu) {
      this.collapseMenu = false;
      this.collapseClick.emit(false);
    } else {
      this.collapseMenu = true;
      this.collapseClick.emit(true);
      if (route) {
        if (route.includes("https")) {
          const url: string = `${environment.usersManulUrl}`;
          window.open(url, '_blank');
        } else {
          this.router.navigateByUrl(route);
        }
      }
    }
  }

  public expandMenu(): void {
    if (this.collapseMenu) {
      this.collapseMenu = false;
      this.collapseClick.emit(false);
    }
  }
}
